import React from 'react';
import { HStack, Heading } from '@chakra-ui/react';

export const titleIconSize="1.5em";
export const titleMB="1.5em";

const PageTitle = ({ icon: Icon, title  }) => {
  return (
    <HStack gap="0.7em" mb={titleMB}>
      <Icon size={titleIconSize} strokeWidth="2.5" />
      <Heading size="2xl">{title}</Heading>
    </HStack>
  );
};

export default PageTitle;